import type { formattedError } from 'app/typings/error';

import { assertNever } from '../typing';

export enum PackageErrorCode {
  PACKAGE_STILL_PUBLISHED = 'packageStillPublished',
  HOTEL_HAS_WRONG_CHECKIN_CHECKOUT_TIMES = 'hotelHasWrongCheckinCheckoutTimes',
  DAY_PACKAGE_HAS_NO_EXPERIENCE_TITLE = 'dayPackageHasNoExperienceTitle',
  CONNECTED_HOTEL_HAVE_PUBLISHED_PACKAGE = 'connectedHotelHavePackagePublished',
}

export const retrievePackageErrorMessage = (
  errorCode: PackageErrorCode
): formattedError => {
  switch (errorCode) {
    case PackageErrorCode.CONNECTED_HOTEL_HAVE_PUBLISHED_PACKAGE:
      return {
        errorTitle: 'You cannot publish more than 1 package for this hotel',
        errorMessage:
          'First, you must change the hotels\' Channel Manager connectivity to "BAR only".',
      };

    case PackageErrorCode.HOTEL_HAS_WRONG_CHECKIN_CHECKOUT_TIMES:
      return {
        errorTitle:
          'You cannot publish the package for this hotel because checkin and checkout times are inconsistent',
        errorMessage:
          "First, you must change the hotels' checkin and checkout times to be in the right order for day experiences.",
      };

    case PackageErrorCode.PACKAGE_STILL_PUBLISHED:
      return {
        errorTitle: undefined,
        errorMessage: 'Another package still published.',
      };
    case PackageErrorCode.DAY_PACKAGE_HAS_NO_EXPERIENCE_TITLE:
      return {
        errorTitle:
          'You cannot publish the package because experience title is required for day packages',
        errorMessage: 'First, you must complete the copywriting form',
      };
    default:
      return assertNever(errorCode);
  }
};
